// Helper function to check if the provided color is a valid hex color code

export const isHexColor = (color: string): boolean => color?.startsWith('#');
